import React from 'react';
import { connect } from 'react-redux';
import PopUp from '../../../../Shared/Popup/PopUp';
import Config from '../../../../../Config';
import { prepareSameWindowUrlWithNavigateTo } from '../../../../../utilities/StringHelpers/StringHelpers';
import SuccessCheckIcon from './SuccessCheckIcon';
import { setIdentitySuccessPopup, goToPage } from '../../saleJetBlockSlice';
import { continueAfterInternetIdentityAsync } from '../../saleBlockAsyncThunk';
import './internetIdentitySuccessPopup.scss';

const InternetIdentitySuccessPopup = (props) => {
  const { isDisplay, contactName } = props.identitySuccessPopup || {};

  const handleClose = () => {
    props.setIdentitySuccessPopup({ isDisplay: false, contactName: '' });
  };

  const handleBackToPersonalArea = () => {
    handleClose();
    prepareSameWindowUrlWithNavigateTo(Config.lobbyUrl);
  };

  const handleContinue = () => {
    handleClose();
    props.continueAfterInternetIdentityAsync();
  };

  const handleAssignOtherId = () => {
    handleClose();
    props.goToPage('internetCustomerInfoPage');
  };

  const bodyText = contactName
    ? `אנחנו ממשיכים עם החשבון הקיים המשוייך לאיש הקשר ${contactName}`
    : 'אנחנו ממשיכים עם החשבון הקיים המשוייך לאיש הקשר';

  return (
    <PopUp
      className='internet-identity-success-popup'
      showPopUp={Boolean(isDisplay)}
      onClose={handleBackToPersonalArea}
      preventWrapperClose={true}
    >
      <div className='internet-identity-success-popup__content'>
        <SuccessCheckIcon />
        <h2 className='internet-identity-success-popup__title'>הזיהוי עבר בהצלחה!</h2>
        <p className='internet-identity-success-popup__text'>{bodyText}</p>
        <button
          type='button'
          className='internet-identity-success-popup__continue'
          onClick={handleContinue}
        >
          המשך
        </button>
        <a
          href='#'
          className='internet-identity-success-popup__secondary'
          onClick={(event) => {
            event.preventDefault();
            handleAssignOtherId();
          }}
        >
          לשיוך לתעודת זהות אחרת
        </a>
      </div>
    </PopUp>
  );
};

const mapStateToProps = (state) => ({
  identitySuccessPopup: state.saleJetBlock.identitySuccessPopup,
});

const mapDispatchToProps = {
  setIdentitySuccessPopup,
  goToPage,
  continueAfterInternetIdentityAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(InternetIdentitySuccessPopup);
